var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1536_9546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.43381,
    y: -0.00012207,
    width: 28.8038,
    height: 30.113,
    rx: 3.92779,
    fill: "#FCC602"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4902 8.67749C14.7712 8.67749 14.21 9.06333 14.21 9.74733C14.21 11.8343 14.4555 14.8332 14.4555 16.9202C14.4556 17.4638 14.9291 17.6918 15.4903 17.6918C15.9112 17.6918 16.5074 17.4638 16.5074 16.9202C16.5074 14.8332 16.7529 11.8343 16.7529 9.74733C16.7529 9.06338 16.1742 8.67749 15.4902 8.67749ZM15.5079 18.9019C14.7363 18.9019 14.1574 19.5157 14.1574 20.2523C14.1574 20.9714 14.7362 21.6027 15.5079 21.6027C16.2269 21.6027 16.8408 20.9714 16.8408 20.2523C16.8408 19.5157 16.2269 18.9019 15.5079 18.9019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4307 8.67737C19.7116 8.67737 19.1504 9.0632 19.1504 9.74721C19.1504 11.8342 19.3959 14.8331 19.3959 16.9201C19.396 17.4637 19.8695 17.6917 20.4307 17.6917C20.8516 17.6917 21.4479 17.4637 21.4479 16.9201C21.4479 14.8331 21.6934 11.8342 21.6934 9.74721C21.6934 9.06326 21.1147 8.67737 20.4307 8.67737ZM20.4483 18.9018C19.6767 18.9018 19.0979 19.5156 19.0979 20.2522C19.0979 20.9712 19.6766 21.6026 20.4483 21.6026C21.1673 21.6026 21.7812 20.9712 21.7812 20.2522C21.7812 19.5156 21.1673 18.9018 20.4483 18.9018Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1536_9546",
    x: 0.815283,
    y: -0.00012207,
    width: 34.0408,
    height: 35.3501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30926
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1536_9546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1536_9546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/MediumIcon.a279cbc1d3a64bdf31904cd9e8ed38a4.svg";
export { ForwardRef as ReactComponent };